import SystemSecretsRoutes from './secrets';
import SystemInternalReadonlyVariablesRoutes from "./internal-versions";

const SystemRoutes = {
  ...SystemSecretsRoutes,
  ...SystemInternalReadonlyVariablesRoutes
};

export default SystemRoutes;
